import { StoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";

import { Config } from "@/utils/config.utils";

import { addressMapper } from "./mappers/address.mapper";
import { storeMapper } from "./mappers/store.mapper";

export const fetchAddressSearchItems = (
    localitiesService: woosmap.map.LocalitiesService,
    inputValue: string,
    limit?: number
) =>
    localitiesService
        .autocomplete({
            input: inputValue.toString(),
            components: {
                country: ["be", "nl", "lu"]
            },
            types: ["address", "locality", "postal_code"],
            language: Config.getLanguage()
        })
        .then(({ localities }) =>
            localities
                .filter((l) => !!l.matched_substrings)
                .slice(0, limit)
                .map(addressMapper)
        );

export const fetchStoreSearchItems = (
    storesService: woosmap.map.StoresService,
    inputValue: string,
    limit?: number,
    filterStoreType?: StoreType
) =>
    storesService
        .autocomplete({
            language: Config.getLanguage(),
            limit: limit,
            query: `localized:"${inputValue}" AND user.locale:="${Config.getLocale()}"${filterStoreType ? ` AND type:"${filterStoreType}"` : ""}`
        })
        .then(({ predictions }) =>
            predictions
                .filter((prediction) => !!prediction.matched_substrings)
                .map(storeMapper)
        );
